export default "__VITE_ASSET__Bci8_8Zk__"